function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IalertTriangle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72943 20.9986H21.2594C22.0294 20.9986 22.5094 20.1686 22.1294 19.4986L12.8594 3.49859C12.4694 2.82859 11.5094 2.82859 11.1294 3.49859L1.85943 19.4986C1.47943 20.1686 1.95943 20.9986 2.72943 20.9986ZM12.9995 17.9985H10.9995V15.9985H12.9995V17.9985ZM11.9995 13.9985C11.4495 13.9985 10.9995 13.5485 10.9995 12.9985V10.9985C10.9995 10.4485 11.4495 9.99854 11.9995 9.99854C12.5495 9.99854 12.9995 10.4485 12.9995 10.9985V12.9985C12.9995 13.5485 12.5495 13.9985 11.9995 13.9985Z",
    fill: "#495057"
  }));
});